var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4491 5.54807L17.6482 7.34893C17.4646 7.53253 17.1677 7.53253 16.9841 7.34893L12.648 3.01282C12.4644 2.82921 12.4644 2.53233 12.648 2.34873L14.4489 0.547873C15.1794 -0.182624 16.3669 -0.182624 17.1013 0.547873L19.4491 2.89562C20.1835 3.62612 20.1835 4.81367 19.4491 5.54807ZM11.1011 3.89566L0.842858 14.1539L0.0147 18.9002C-0.0985858 19.5408 0.46003 20.0955 1.10068 19.9861L5.84696 19.1541L16.1052 8.89586C16.2888 8.71226 16.2888 8.41537 16.1052 8.23177L11.7691 3.89566C11.5816 3.71206 11.2847 3.71206 11.1011 3.89566ZM4.84692 13.2749C4.63207 13.0601 4.63207 12.7163 4.84692 12.5015L10.8628 6.48561C11.0776 6.27076 11.4214 6.27076 11.6363 6.48561C11.8511 6.70046 11.8511 7.04423 11.6363 7.25908L5.62039 13.2749C5.40554 13.4898 5.06178 13.4898 4.84692 13.2749ZM3.43671 16.5602H5.31179V17.9783L2.79215 18.4197L1.57726 17.2048L2.01869 14.6852H3.43671V16.5602Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/editWhite.5d48f9033ae402a9a129c5fcdeacb598.svg";
export { ForwardRef as ReactComponent };